import { encodeObject } from "./objectEncoderDecoder";
import { warn } from "rtUtils/logger";

const serializeProductConfigs = (configs) => {
	let serialized = "";

	try {
		serialized = configs?.length ?
			configs.map((txt) => {
				return encodeObject(txt);
			}).join(",") :
			"";
	} catch (ex) {
		warn("failed to encode product configs for URL", ex);
	}
	return serialized;
};

export default serializeProductConfigs;
